import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { workerFilterConfig } from '@/lib/filters/configs/worker-filters';

// The filter params must be declared here, or TanStack Router strips them on every navigate.
// Their absence is why this page's filters used to be held in a Zustand store and pushed to the
// URL with a raw history.replaceState, behind the router's back (W4.T6.0).
export const Route = createFileRoute('/workforce/')({
  validateSearch: generateValidateSearch(workerFilterConfig),
});
